import { Link } from "react-router-dom";
import heroImage from "../../assets/family-hero.jpg";

function Probate() {
  return (
    <>
      {/* ================= HERO ================= */}
      <section className="relative h-[80vh] flex items-center justify-center pt-24">

        {/* BACKGROUND IMAGE */}
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url(${heroImage})`,
          }}
        ></div>

        {/* OVERLAY */}
        <div className="absolute inset-0 bg-black/60"></div>

        {/* CONTENT */}
        <div className="relative z-10 text-center text-white px-6 max-w-3xl">
          <h1 className="text-4xl md:text-6xl font-dancing-script">
            Family & Succession Law
          </h1>

          <p className="mt-4 text-lg text-gray-200">
            
          </p>
        </div>

      </section>

      {/* ================= CONTENT ================= */}
      <section className="py-20 px-6 bg-white">
        <div className="max-w-4xl mx-auto text-center">

          <p className="text-gray-700 text-lg leading-relaxed">
  Family and succession law focuses on protecting relationships, preserving
  dignity, and securing the future of families across generations.
  At <strong>GATI & CO. ADVOCATES</strong>, we understand that matters involving
  family, children, inheritance, and legacy require not only legal expertise,
  but also sensitivity, discretion, and strategic guidance.
</p>

<p className="mt-6 text-gray-700 text-lg leading-relaxed">
  Guided by our philosophy of <span className="italic">“Protecting blood and legacy,”</span>
  we provide comprehensive legal support in divorce and separation matters,
  including petition filing, division of matrimonial property, and alimony.
  We also handle children’s matters such as custody, access, maintenance,
  and guardianship while prioritizing the best interests of the child.
</p>

<p className="mt-6 text-gray-700 text-lg leading-relaxed">
  Our practice further extends to adoption proceedings, including local
  adoption applications and liaison with the Children’s Department.
  In succession matters, we assist clients with custom will drafting,
  grants of probate, letters of administration, and estate management,
  ensuring that family wealth, wishes, and legacy are preserved and
  transferred lawfully and efficiently.
</p>

        </div>
      </section>

      {/* ================= NAV BUTTONS ================= */}
      <section className="py-12 px-6 bg-gray-100 border-t border-gray-200">
        <div className="max-w-7xl mx-auto flex justify-between items-center">

          {/* LEFT BUTTON */}
          <Link
            to="/services"
            className="px-6 py-3 border-2 border-[#0B3D91] text-[#0B3D91] bg-white rounded-lg font-semibold hover:bg-[#0B3D91] hover:text-white transition hover:-translate-x-1"
          >
            ← Back to practice areas
          </Link>

          {/* RIGHT BUTTON */}
          <Link
            to="/services"
            className="px-6 py-3 bg-[#0B3D91] text-white rounded-lg font-semibold hover:bg-blue-800 transition hover:translate-x-1"
          >
            All Services →
          </Link>

        </div>
      </section>
    </>
  );
}

export default Probate;